// extracted by mini-css-extract-plugin
module.exports = {"option":"Option_option__HDOqd","main":"Option_main__ecdaD","legend":"Option_legend__H1TiJ","checked":"Option_checked__HptA2","priceWrapper":"Option_priceWrapper___3y2d"};